// Dernier espace choisi (entreprise | patient) : sert uniquement à l'espace affiché par défaut, jamais aux sessions.
const KEY = "sanitdocs.space";
export const getSpace = () => { try { const v = localStorage.getItem(KEY); return v === "entreprise" || v === "patient" ? v : null; } catch { return null; } };
export const setSpace = (s) => { try { s ? localStorage.setItem(KEY, s) : localStorage.removeItem(KEY); } catch {} };
